export default "__VITE_ASSET__DvYxdslE__"